import { Button, InfoPage, isLoggedIn } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";

function VerifyEmailSuccess() {
  const navigation = useNavigation();
  const buttonText = isLoggedIn() ? "Back to Account" : "Back to Login";
  function navigateOnClick() {
    isLoggedIn() ? navigation.goToProfile() : navigation.goToSignIn();
  }

  return (
    <InfoPage
      variant="success"
      title="Email verified"
      description="Your account works across all supported devices: iPad, Mac, Windows and Vision Pro."
      primaryCTA={<Button onClick={navigateOnClick}>{buttonText}</Button>}
    />
  );
}

export default VerifyEmailSuccess;
